"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderReact = exports.Header = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var HeaderReact = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(HeaderReact, _React$PureComponent);
  var _super = _createSuper(HeaderReact);
  function HeaderReact() {
    (0, _classCallCheck2.default)(this, HeaderReact);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(HeaderReact, [{
    key: "returnHeaderLogo",
    value: function returnHeaderLogo(siteInfo) {
      if (!siteInfo) {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "visible-sm"
        }, /*#__PURE__*/_react.default.createElement("a", {
          id: "header-logo",
          href: ""
        }));
      } else if (siteInfo.realm !== 'LCYTS' && siteInfo.realm !== 'LCK12') {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "visible-sm"
        }, /*#__PURE__*/_react.default.createElement("a", {
          id: "header-logo",
          className: "logo icon-logo icon-logo-lcps-logo",
          href: siteInfo.homePageURL
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "brand-text"
        }, "Patient Solutions"));
      }
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "visible-sm"
      }, /*#__PURE__*/_react.default.createElement("a", {
        id: "header-logo",
        className: "icon-logo icon-logo-yts-logo",
        href: siteInfo.homePageURL
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var siteInfo = this.props.siteInfo;
      return /*#__PURE__*/_react.default.createElement("header", {
        id: "com-header-react"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "page-header "
      }, /*#__PURE__*/_react.default.createElement("nav", {
        className: "com-header-nav Pos-R",
        role: "navigation"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "com-header-brand-area pull-left padding-top-20 padding-bottom-15"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "com-header-logo"
      }, this.returnHeaderLogo(siteInfo))), /*#__PURE__*/_react.default.createElement("h2", {
        className: "margin-left-20 header-title pull-left"
      }, " ", siteInfo.pageTitle, " "), /*#__PURE__*/_react.default.createElement("div", {
        className: "pull-right visible-sm"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "clearfix visible-sm"
      }))));
    }
  }]);
  return HeaderReact;
}(_react.default.PureComponent);
exports.HeaderReact = HeaderReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    siteInfo: state.siteInfo
  };
};
HeaderReact.propTypes = {
  siteInfo: _propTypes.default.object.isRequired
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Header = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HeaderReact);
exports.Header = Header;
